import React from 'react';
import { inject, observer } from 'mobx-react';
import { Flex } from 'grid-styled';

import ProtoSelect from '../form/ProtoSelect';
import HTTPSelect from '../form/HTTPSelect';
import Checkbox from '../form/Checkbox';
import { LabelInput } from '../form/LabelInput';

import NetworkModel from '../models/NetworkModel';

import Background from '../assets/alert-circle.png';
import BusyOverlay from '../uic/BusyOverlay';
import { Label } from '../styledSystem/Text';
import { BoxTemplate } from '../styledSystem/Box';
import Button from '../uic/Button';

import session from '../session';
import Section from '../uic/Section';
import { List, Row } from '../uic/list';

class Network extends React.Component {
    state = {
        editable: false,
        editfields: true,
        formErrors: {
            netmask: '',
            ipaddr: '',
            gateway: '',
            dns: '',
            alternativedns: '',
            sonicipvolume: ''
        },
        formValid: false,
        sonicipchecked: false,
        buttonState: false,
        hideEdit: true
    };

    changeStateActions = () => {};

    editNetwork = () => {
        this.model.clear();

        this.setState({
            editable: !this.state.editable,
            editfields: true,
            formErrors: {
                protocol: '',
                dhcpname: '',
                ipaddr: '',
                netmask: '',
                gateway: '',
                dns: '',
                alternativedns: '',
                sonicipenable: '',
                sonicipvolume: ''
            },
            formValid: false,
            sonicipchecked: false
        });
    };

    componentWillMount() {
        this.model = new NetworkModel(session);
        this.model.load();

        if (session.user === 'user') {
            //
            this.setState({ hideEdit: true });
        }
        if (session.user === 'admin') {
            //
            this.setState({ hideEdit: false });
        }
    }

    onSave = async () => {
        console.log('NetworkSave: start');
        try {
            this.setState({
                buttonState: true,
                editfields: false,
                editable: false
            });

            let sessionResultSonic,
                sessionResultNetwork,
                sessionResultHTTP,
                sessionResultCommit = '';
            const { session } = this.props;

            sessionResultSonic = await session.rpc('call', [
                '',
                'uci',
                'set',
                {
                    config: 'network',
                    section: 'sonic_ip',
                    values: {
                        enabled: this.model.sonicip.toString(),
                        volume: this.model.sonicipvolume.toString()
                    }
                }
            ]);

            if (this.model.proto === 'static') {
                sessionResultNetwork = await session.rpc('call', [
                    '',
                    'uci',
                    'set',
                    {
                        config: 'network',
                        section: 'eth0',
                        values: {
                            proto: this.model.proto.toString(),
                            ipaddr: this.model.ipaddr.toString(),
                            netmask: this.model.netmask.toString(),
                            gateway: this.model.gateway.toString(),
                            dns1: this.model.dns.toString(),
                            dns2: this.model.alternativeDNS.toString(),
                            dhcpname: this.model.dhcpname.toString()
                        }
                    }
                ]);
            } else if (this.model.proto === 'dhcp') {
                sessionResultNetwork = await session.rpc('call', [
                    '',
                    'uci',
                    'set',
                    {
                        config: 'network',
                        section: 'eth0',
                        values: {
                            proto: this.model.proto.toString(),
                            dhcpname: this.model.dhcpname.toString()
                        }
                    }
                ]);

                await session.rpc('call', [
                    '',
                    'network',
                    'hostname_set',
                    {
                        hostname: this.model.dhcpname.toString()
                    }
                ]);
            }

            sessionResultHTTP = await session.rpc('call', [
                '',
                'uci',
                'set',
                {
                    config: 'httpd',
                    section: 'webserver',
                    values: {
                        protocol: this.model.webproto.toString()
                    }
                }
            ]);

            if (
                sessionResultNetwork[1].status === 'OK' &&
                sessionResultSonic[1].status === 'OK' &&
                sessionResultHTTP[1].status === 'OK'
            ) {
                sessionResultCommit = await session.rpc('call', [
                    '',
                    'uci',
                    'commit',
                    {}
                ]);

                /*if (sessionResultCommit[1].status === 'OK') {
                    await this.model.load();
                    this.setState({
                        buttonState: false
                    });
                }*/
            }

            //sleep for luck
            await new Promise(r => setTimeout(r, 5000));

            let currentProtocol = window.location.protocol;
            console.log("currentProtocol: ", currentProtocol)
            console.log("protocol set: ",this.model.webproto.toLowerCase());

            if (currentProtocol.replace(':','').toLowerCase() === this.model.webproto.toLowerCase()){
                //if web protocol did not changed, simple model load
                console.log("protocols matched => simple model load")
                this.setState({
                    buttonState: false
                });
                await this.model.load();

            } else {
                //else, page reload using new web protocol
                let protocol = this.model.webproto.toLowerCase();
                let url = protocol + "://" + window.location.hostname + window.location.pathname;
                console.log("protocols did not matched => url: ", url)
                this.setState({
                    buttonState: false
                });
                await window.open(url, "_self")

            }
        } catch (err) {
            console.error('NetworkSave:' + err);
        }
        console.log('NetworkSave: end');
    };

    updateState = variableName => {
        console.log('Network update:' + JSON.stringify(variableName));
        this.setState(variableName);
    };

    render() {
        const model = this.model;

        return (
            <Flex flexDirection={['column', 'row']}>
                {this.state.buttonState && <BusyOverlay />}
                <Section title="Network">
                    <List>
                        <Row>
                            {this.state.editfields && this.state.editable ? (
                                <HTTPSelect
                                    label="Web Protocol"
                                    model={model}
                                    name="webproto"
                                    updateState={this.updateState}
                                />
                            ) : (
                                <LabelInput
                                    label="Web Protocol"
                                    model={model}
                                    name="webproto"
                                    statevariable={this.state}
                                    updateState={this.updateState}
                                    readOnly={
                                        !this.state.editfields ||
                                        !this.state.editable
                                    }
                                />
                            )}
                        </Row>
                        <Row>
                            {this.state.editfields && this.state.editable ? (
                                <ProtoSelect
                                    label="Protocol"
                                    model={model}
                                    name="proto"
                                    updateState={this.updateState}
                                />
                            ) : (
                                <LabelInput
                                    label="Protocol"
                                    model={model}
                                    name="proto"
                                    statevariable={this.state}
                                    updateState={this.updateState}
                                    readOnly={
                                        !this.state.editfields ||
                                        !this.state.editable
                                    }
                                />
                            )}
                        </Row>
                        <Row>
                            <LabelInput
                                label="DHCP Name"
                                model={model}
                                readOnly={
                                    !this.state.editfields ||
                                    !this.state.editable
                                }
                                name="dhcpname"
                                statevariable={this.state}
                                updateState={this.updateState}
                                background={Background}
                                errormask={this.state.formErrors.dhcpname}
                            />
                        </Row>

                        <Row>
                            <LabelInput
                                label="IP Address"
                                model={model}
                                name="ipaddr"
                                statevariable={this.state}
                                updateState={this.updateState}
                                readOnly={
                                    !this.state.editfields ||
                                    !this.state.editable ||
                                    (this.state.editable &&
                                        model.proto === 'dhcp')
                                }
                                errormask={this.state.formErrors.ipaddr}
                                background={Background}
                            />
                        </Row>
                        <Row>
                            <LabelInput
                                label="Netmask"
                                model={model}
                                name="netmask"
                                statevariable={this.state}
                                updateState={this.updateState}
                                readOnly={
                                    !this.state.editfields ||
                                    !this.state.editable ||
                                    (this.state.editable &&
                                        model.proto === 'dhcp')
                                }
                                errormask={this.state.formErrors.netmask}
                                background={Background}
                            />
                        </Row>
                        <Row>
                            <LabelInput
                                label="Gateway"
                                model={model}
                                name="gateway"
                                statevariable={this.state}
                                updateState={this.updateState}
                                readOnly={
                                    !this.state.editfields ||
                                    !this.state.editable ||
                                    (this.state.editable &&
                                        model.proto === 'dhcp')
                                }
                                errormask={this.state.formErrors.gateway}
                                background={Background}
                            />
                        </Row>
                        <Row>
                            <LabelInput
                                label="Primary DNS"
                                model={model}
                                name="dns"
                                statevariable={this.state}
                                updateState={this.updateState}
                                readOnly={
                                    !this.state.editfields ||
                                    !this.state.editable ||
                                    (this.state.editable &&
                                        model.proto === 'dhcp')
                                }
                                errormask={this.state.formErrors.dns}
                                background={Background}
                            />
                        </Row>
                        <Row>
                            <LabelInput
                                label="Alternative DNS"
                                model={model}
                                name="alternativeDNS"
                                statevariable={this.state}
                                updateState={this.updateState}
                                readOnly={
                                    !this.state.editfields ||
                                    !this.state.editable ||
                                    (this.state.editable &&
                                        model.proto === 'dhcp')
                                }
                                errormask={this.state.formErrors.alternativedns}
                                background={Background}
                            />
                        </Row>
                        <Row>
                            {this.state.editfields && this.state.editable ? (
                                <Checkbox
                                    label="SonicIP®"
                                    model={model}
                                    name="sonicip"
                                    statevariable={this.state}
                                    updateState={this.updateState}
                                    errormask={
                                        this.state.formErrors.sonicipenable
                                    }
                                />
                            ) : (
                                <React.Fragment>
                                    <BoxTemplate
                                        display="inline-block"
                                        w={1 / 2}
                                    >
                                        <Label textStyle="labelNormal">
                                            SonicIP®
                                        </Label>
                                    </BoxTemplate>
                                    <BoxTemplate
                                        display="inline-block"
                                        w={1 / 2}
                                    >
                                        {model['sonicip'] === 'true' ? (
                                            <Label textStyle="labelBold">
                                                ON
                                            </Label>
                                        ) : (
                                            <Label textStyle="labelBold">
                                                OFF
                                            </Label>
                                        )}
                                    </BoxTemplate>
                                </React.Fragment>
                            )}
                        </Row>
                        <Row>
                            <LabelInput
                                label="SonicIP® Volume"
                                model={model}
                                name="sonicipvolume"
                                statevariable={this.state}
                                updateState={this.updateState}
                                readOnly={
                                    !this.state.editfields ||
                                    !this.state.editable
                                }
                                errormask={this.state.formErrors.sonicipvolume}
                                background={Background}
                            />
                        </Row>
                    </List>

                    <BoxTemplate minheight="15px" />
                    <Flex justifyContent="flex-end">
                        {this.state.editable ? (
                            <React.Fragment>
                                <Button icon="close" onClick={this.editNetwork}>
                                    Cancel
                                </Button>

                                <Button
                                    icon="check"
                                    onClick={this.onSave}
                                    disabled={!this.state.formValid}
                                    disabledStyle={{ color: 'redRed' }}
                                >
                                    Save
                                </Button>
                            </React.Fragment>
                        ) : (
                            !this.state.hideEdit && (
                                <Button onClick={this.editNetwork} icon="edit">
                                    Edit
                                </Button>
                            )
                        )}
                    </Flex>
                </Section>

                <Section title="Help">
                    <p>
                        <b>DHCP Name: </b>
                        Name of the device sent in DHCP request.
                        <br />
                    </p>
                    <p>
                        <b>IP Address: </b>
                        Enter the 4 values of the desired device IP address,
                        e.g. '192.168.0.12' for an internal LAN
                        <br />
                        Default: '0.0.0.0'
                    </p>
                    <p>
                        <b>Netmask: </b>
                        Enter the 4 values of the desired subnet mask e.g.:
                        <br />
                        '0.0.0.0' for a default Netmask depending on the used IP
                        Address.
                        <br />
                        '255.255.255.0' for a C class network.
                        <br />
                        Default: '255.255.255.0'
                    </p>
                    <p>
                        <b>Gateway: </b>
                        Enter the 4 values of the desired Gateway IP address
                        e.g.:
                        <br />
                        '0.0.0.0' for no Gateway
                        <br />
                        '192.168.0.1' for a Gateway in a LAN
                        <br />
                        Note: The Gateway has to be set only when connecting to
                        other devices over the WAN (through a router).
                        <br />
                        Default: '0.0.0.0'
                    </p>
                    <p>
                        <b>Primary DNS: </b>
                        In this field, you can give this device the desired
                        primary and alternative DNS IP address to be able to
                        connect to URLs (e.g. www.radio.com).
                        <br />
                        Example: '195.186.1.111'
                        <br />
                        Default: '0.0.0.0'
                    </p>
                    <p>
                        <b>Alternative DNS: </b>
                        In this field, you can give this device the desired
                        alternative DNS IP address in case the primary DNS is
                        not reachable.
                        <br />
                        Example: 195.186.1.111
                        <br />
                        Default: '8.8.8.8'
                    </p>
                    <p>
                        <b>Sonic IP: </b>
                        If enabled, the device will announce its IP address over
                        the audio output.
                    </p>
                </Section>
            </Flex>
        );
    }
}

export default inject('session')(observer(Network));



// WEBPACK FOOTER //
// ./src/pages/Network.js